import { routes } from "../../../constants/routes";
export interface RequestsList {
  totalRecords: number | null;
  data: Request[];
}
export interface Request {
  name: string | null;
  email: string | null;
  phone_number: string | null;
  created_at: string | null;
  status: "REQUESTED_ACCESS";
}
export interface SortOption {
  sortDirection: string | null;
  sortBy: string | null;
}
export interface RequestsListParams {
  limit: string | number;
  offset: string | number;
  sortDirection?: string | null;
  sortBy?: string | null;
  searchText?: string;
  status?: string[];
  isRequestAccess?: boolean;
}

export const breadcrumbLink = [
  {
    label: "Partner Management",
    link: "#",
    handleClick: () => {},
  },
  {
    label: "Partner Requests",
    link: routes.PARTNERLIST,
    handleClick: () => {},
  },
];

export function getPOCName(tenantPrimaryUser: any) {
  try {
    return `${tenantPrimaryUser.first_name} ${tenantPrimaryUser.last_name}`.trim();
  } catch (error: unknown) {
    console.error("Error in fetching tenant primary user:", error);
  }
}
